"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SellerProblemsViewClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const core_auth_1 = require("@deliverr/core-auth");
const client_auth_1 = require("@deliverr/client-auth");
const defaultConfig = {
    authEngine: core_auth_1.AuthEngine.UNKNOWN,
    baseURL: process.env.INBOUND_SERVICE_URL,
};
class SellerProblemsViewClient extends base_client_1.ApiClient {
    constructor(config = {}) {
        const logCtx = { fn: "SellerProblemsViewClient#constructor" };
        const clientConfig = Object.assign(Object.assign({}, defaultConfig), config);
        if (clientConfig.authEngine === core_auth_1.AuthEngine.UNKNOWN) {
            throw new Error("authEngine for SellerProblemsViewClient is not set");
        }
        if (clientConfig.authEngine === core_auth_1.AuthEngine.COGNITO_INTERNAL) {
            const tokenHandler = new client_auth_1.OAuthClientTokenBuilder(config);
            clientConfig.tokenRefreshFn = tokenHandler.getTokenFn();
        }
        if (!clientConfig.baseURL) {
            commons_logs_1.log.warn(logCtx, "baseURL is not configured");
        }
        super(clientConfig);
    }
    async getSellerProblemsDetailView(sellerProblemId, sellerProblemType) {
        const url = `/v1/seller-problems/detailView/query`;
        try {
            return this.post(url, {
                sellerProblemId,
                sellerProblemType,
            });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async getSellerProblemsBySellerId(sellerId) {
        const url = `/v1/non-compliance/seller-problems-view/seller/query`;
        try {
            return this.post(url, { sellerId });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async getSellerProblemsByShipmentId(shipmentId) {
        const url = `/v1/seller-problems/shipmentId/query`;
        try {
            return await this.post(url, { shipmentId });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async getSellerProblemsBySellerIdAndProblemTypes(sellerId, sellerProblemTypes) {
        const url = `/v1/non-compliance/seller-problems-view/sellerId/problemType/query`;
        try {
            return await this.post(url, {
                sellerId,
                sellerProblemTypes,
            });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async searchSellerProblems(request) {
        const url = `/v1/seller-problems/search`;
        try {
            return await this.post(url, request);
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async getDetailedSellerProblems(shipmentIds, shippingPlanIds) {
        const url = `/v1/seller-problems/detailView/shippingPlanId/shipmentId/query`;
        try {
            return await this.post(url, { shipmentIds, shippingPlanIds });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async getSellerProblemOverviewBySellerProblemIdAndType(sellerProblemId, type) {
        const url = `/v1/seller-problems/sellerProblemId/type/query`;
        try {
            return await this.post(url, { sellerProblemId, sellerProblemType: type });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async acknowledgeSellerProblemBySellerProblemIdAndType(sellerProblemId, type) {
        const url = `/v1/seller-problems/sellerProblemId/type/acknowledge`;
        try {
            return this.post(url, {
                sellerProblemId,
                type,
            });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async acknowledgeSellerProblemBySellerProblemViewId(sellerProblemViewId) {
        const url = `/v1/seller-problems/id/acknowledge`;
        try {
            return await this.post(url, { id: sellerProblemViewId });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async getUnresolvedCount(sellerId) {
        const url = `/v1/seller-problems/unresolved-count/query`;
        try {
            return await this.post(url, { sellerId });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async completeMissingBarcodeProductIdentification(body) {
        const url = "/v1/seller-problems/missingBarcode/product/identification/completion";
        try {
            return await this.post(url, body);
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async failedToIdentifyProductForMissingBarcode(sellerProblemId) {
        const url = "/v1/seller-problems/missingBarcode/product/identification/failure";
        try {
            return await this.post(url, {
                sellerProblemId,
            });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async completeUnknownBarcodeProductIdentification(body) {
        const url = "/v1/seller-problems/unknownBarcode/product/identification/completion";
        try {
            return await this.post(url, body);
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async failedToIdentifyProductForUnknownBarcode(sellerProblemId) {
        const url = "/v1/seller-problems/unknownBarcode/product/identification/failure";
        try {
            return await this.post(url, {
                sellerProblemId,
            });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async disputeDamagedProduct(sellerProblemId) {
        const url = "/v1/seller-problems/damagedProduct/dispute/submission";
        try {
            return await this.post(url, {
                sellerProblemId,
            });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    async getActionNeededShipmentsBySellerId(sellerId) {
        const url = `/v1/seller-problems/shipments/query/actionNeeded`;
        try {
            return await this.post(url, { sellerId });
        }
        catch (error) {
            this.handleNonComplianceError(error);
        }
    }
    handleNonComplianceError(error) {
        throw this.maybeGetDeliverrError(error) || this.maybeGetNetworkError(error) || this.getUnknownError(error);
    }
}
exports.SellerProblemsViewClient = SellerProblemsViewClient;
exports.default = SellerProblemsViewClient;
//# sourceMappingURL=SellerProblemsViewClient.js.map